import styled from 'styled-components';
import React, { ChangeEvent } from 'react';

type InputProps = {
  id: string;
  value: string;
  label: string;
  name?: string;
  padding?: string;
  maxWidth?: string;
  placeholder: string;
  required?: boolean;
  onChange: ({ target }: ChangeEvent<HTMLInputElement>) => void;
};

function Input({
  name,
  value,
  id,
  label,
  onChange,
  placeholder,
  padding,
  required,
  maxWidth,
}: InputProps) {
  return (
    <InputWrapper $maxWidth={maxWidth}>
      <LabelWrapper>
        <StyledLabel htmlFor={id}>{label}</StyledLabel>
        {required && <Asterics>*</Asterics>}
      </LabelWrapper>

      <StyledInput
        type="text"
        id={id}
        name={name}
        value={value}
        $padding={padding}
        onChange={onChange}
        placeholder={placeholder}
      />
    </InputWrapper>
  );
}

const StyledInput = styled.input<{ $padding?: string }>`
  height: 50px;
  width: 100%;

  background-color: ${({ theme }) => theme.colors.athensGray};
  color: ${({ theme }) => theme.colors.textPrimary};

  border: none;
  border-radius: 12px;
  padding: ${({ $padding }) => $padding ?? '10px 16px'};

  font-size: 16px;

  &:focus {
    border: 0;
    outline: 0;
    -webkit-appearance: none;
  }
`;

const StyledLabel = styled.label`
  font-weight: 500;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textPrimary};

  margin-bottom: 10px;
`;

const InputWrapper = styled.div<{ $maxWidth?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 82px;
  width: 100%;
  max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : '420px')};
  margin-bottom: 10px;
`;

const Asterics = styled.span`
  position: relative;
  font-size: 20px;
  top: -6px;
  left: 2px;
`;

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export default Input;
